export default __webpack_public_path__ + "static/media/portada6.5d900852.jpg";